export default "__VITE_ASSET__vek$R2je__"